export interface IState {
  isAuth: boolean
  user: string
}

interface IUser {
  type: 'USER'
  payload: string
}

export type Actions = IUser

export const initialState: IState = {
  isAuth: false,
  user: '',
}

export const reducer = (state: IState, action: Actions) => {
  switch (action.type) {
    case 'USER':
      return { ...state, isAuth: true, user: action.payload }
    default:
      return { ...state }
  }
}
